import { HOUR_MS } from '@app/core/consts';
import { fitFixedDurationInBounds } from '@app/core/range';
import { roundToSeconds, TimeRange } from '@mi-front/core';

export interface GetGoToTimeStreamRangeOptions {
  /** Target timestamp in ms. The computed range will be 1 hour long starting at this time (rounded to seconds). */
  ts: number;
  /** Allowed [from, to] bounds. The returned range is always enclosed within this range. */
  streamableRange: TimeRange<number>;
}

/**
 * Computes the stream range (from, to) for "go to time" navigation.
 * Returns a 1-hour range starting at ts (rounded to seconds), enclosed in streamableRange.
 * Delegates to fitFixedDurationInBounds with anchor 'start'.
 */
export function getGoToTimeStreamRange(options: GetGoToTimeStreamRangeOptions): TimeRange<number> {
  const { ts, streamableRange } = options;
  const startTs = roundToSeconds(ts);

  return fitFixedDurationInBounds({
    anchorTs: startTs,
    durationMs: HOUR_MS,
    bounds: streamableRange,
    anchor: 'start',
  });
}
